import Vue from 'vue';
import Component from 'vue-class-component';

/**
 * Shows the companies logo and holds the translation selection.
 */
@Component({
  name: 'HeaderBar',
})
export default class HeaderBar extends Vue {
  private currentLanguage = 'de';

  get backNavigation() {
    return this.$store.state.backNavigation;
  }

  /**
   * Gets lang from local storage.
   */
  mounted() {
    const lang = localStorage.getItem('lang');
    if (lang !== null) this.currentLanguage = lang;
    this.$i18n.locale = this.currentLanguage;
  }

  /**
   * Sets the language.
   *
   * @param lang - selected language
   */
  private setLanguage(lang: string) {
    localStorage.setItem('lang', lang);
    this.currentLanguage = lang;
    this.$i18n.locale = lang;
  }
}
